export const ADMINISTRATOR_ROLE_ID =
  process.env.REACT_APP_ENV === 'production'
    ? '63a4a17df3d917db94e0d4d0'
    : '63e22310363f1e561f237b43';
